import { createAsyncThunk } from '@reduxjs/toolkit'
import { newsletterSignupApi } from 'src/services/oms'
import type { MetaStateInReducer } from '../meta'

export const newsletterSignupAction = createAsyncThunk(
  '@newsletter/newsletterSignup',
  async (
    {
      email,
      firstName,
      lastName
    }: {
      email: string
      firstName: string
      lastName: string
    },
    thunkApi
  ) => {
    const state = thunkApi.getState() as MetaStateInReducer
    const menuId = state['@meta'].detailMenuSite.data.menu.id
    const result = await newsletterSignupApi({
      email,
      firstName,
      lastName,
      menuId
    })
    return result.data
  }
)
